module.exports = __webpack_public_path__ + "static/media/credit-card-logos.5bb7f6de.png";